export default state => state.address?.deliveryAddressList?.savedAddressIds.map(addressId => (
  state.address?.deliveryAddressList?.addresses[addressId]))?.length > 0;
